<script>

export default {
    inserted: (el,binding) => {
        let data = binding.value.text;
        let typeLinks = el.querySelectorAll('ul li a');
        let typeList = el.querySelectorAll('ul li');
        let products = el.querySelectorAll('.adventure-setups-image-container');
        let mainContainer = el.querySelector('.adventure-setups-container');
        let title = el.querySelector('h3#adventure-setups-title');

        let mobileMenuButton = el.querySelector('.mobile-menu > div');

        let setOnclick = (element) => {
            element.onclick = (e) => {
                e.preventDefault();
                updateUI(element);
            }

            element.parentElement.onclick = (e) => {
                e.preventDefault();
                updateUI(element);
            }
        }

        for(let element of typeLinks) {
            setOnclick(element);
        }

        let reset = () => {
            for(let element of typeList) {
                element.classList.remove('active');
            }

            for(let product of products) {
                product.style.display = 'none';
            }
        }

        let changeProduct = (type) => {
            for(let product of products) {
                if(product.dataset.type === type) {
                    product.style.display = 'flex';
                }
            }
        }

        let changeBackgroundImage = (url) => {
            mainContainer.style.backgroundImage = 'url(' + url + ')';
        }

        let changeTitle = (type) => {
            title.innerText = type;
        }

        mobileMenuButton.onclick = function() {
            mobileMenuButton.classList.toggle('open');
            let navigation = el.querySelector('.adventure-setups-navigation');
            navigation.classList.toggle('active');
        }

        let changeMobileMenu = (title, icon) => {
            let menuTitle = document.querySelector('#mobile-menu-title');
            let menuIcon = document.querySelector('#mobile-menu-icon');
            menuTitle.innerText = title;
            menuIcon.className = 'icon ' + icon;
            
            let navigation = el.querySelector('.adventure-setups-navigation');
            navigation.classList.remove('active');
            mobileMenuButton.classList.remove('open');
        }

        let updateUI = (element) => {
            let menuTitle = element.querySelector('.title').innerText;
            let icon = element.querySelector('i').classList[1];
            let type = element.dataset.type;
            reset();
            element.parentElement.classList.add('active');
            var result = data.find(item => item.field_4 === type);
            var img = result.field_2;
            var title = result.field_1;

            changeProduct(type);
            changeBackgroundImage(img);
            changeTitle(title);
            changeMobileMenu(menuTitle, icon);
        }

        let setPointerOnclick = function(ctl, i) {
            ctl.onclick = function() {
                let pointers = document.getElementsByClassName('pointer');
                for(let bi = 0; bi < pointers.length; bi++) {
                    pointers[bi].classList.remove('active')
                }
                ctl.parentElement.classList.add('active')
            }
            ctl.parentElement.getElementsByTagName('svg')[0].onclick = function(e) {
                ctl.parentElement.classList.remove('active');
            }
        } 

        let pointers = document.getElementsByClassName('pointer');
        for(let bi = 0; bi < pointers.length; bi++) {
            setPointerOnclick(pointers[bi].getElementsByTagName('i')[0], bi);
        }
    }
}
</script>